import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgClipboardList = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M13.3334 3.33366H15C15.4421 3.33366 15.866 3.50925 16.1786 3.82181C16.4911 4.13437 16.6667 4.5583 16.6667 5.00033V16.667C16.6667 17.109 16.4911 17.5329 16.1786 17.8455C15.866 18.1581 15.4421 18.3337 15 18.3337H5.00004C4.55801 18.3337 4.13409 18.1581 3.82153 17.8455C3.50897 17.5329 3.33337 17.109 3.33337 16.667V5.00033C3.33337 4.5583 3.50897 4.13437 3.82153 3.82181C4.13409 3.50925 4.55801 3.33366 5.00004 3.33366H6.66671M13.333 11.5004H6.66638M13.333 14.6702H6.66638M10.0004 8.32328H6.66638M7.50004 1.66699H12.5C12.9603 1.66699 13.3334 2.04009 13.3334 2.50033V4.16699C13.3334 4.62723 12.9603 5.00033 12.5 5.00033H7.50004C7.0398 5.00033 6.66671 4.62723 6.66671 4.16699V2.50033C6.66671 2.04009 7.0398 1.66699 7.50004 1.66699Z",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgClipboardList;
